// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2Uqwb","item":"PaymentsMobile_item__3EKcK","label":"PaymentsMobile_label__2evZG","amount":"PaymentsMobile_amount__2UC8t"};